<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.oci"
            ref="DataTable"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="edit(item.id)"
                    authorize="update-cadastro-oci"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :color="item.ativo ? 'dark' : 'success'"
                    :title="item.ativo ? 'Desativar' : 'Ativar'"
                    @click="item.ativo ? deactivate(item.id) : activate(item.id)"
                    small
                >
                    <rkm-icon :icon="item.ativo ? 'ban' : 'check-circle'" />
                </rkm-button>

                <rkm-button
                    :disabled="!!item.hasVinculos"
                    @click="destroy(item.id)"
                    authorize="destroy-cadastro-oci"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalDesativacao ref="ModalDesativacao" />
    </div>
</template>

<script>
// Components.
import ModalDesativacao from './components/desativacao/Modal'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

export default {
    components: { ModalDesativacao },
    created() {

        this.repositories = {
            oci: this.getConectaSusRepository('cadastro.oci')
        }
    },
    data: () => ({
        fields: [
            { key: 'nome', name: 'oci.nome', label: 'Nome', searchable: true, sortable: true },
            { key: 'procedimentoDescricao', name: 'procedimentoDescricao', label: 'Procedimento principal', searchable: true, sortable: true },
            { key: 'linhaCuidado', name: 'oci.linhaCuidado', label: 'Linha de cuidado', searchable: true, sortable: true },
            { key: 'codigo', name: 'oci.codigo', label: 'Código', searchable: true, sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        edit(id) {

            this.$router.push({ name: 'cadastro-oci-edit', params: { id } })
        },
        destroy(id) {

            const destroy = () => this.repositories.oci.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a OCI?', destroy, this.handleError)
        },
        activate(id) {

            const activate = () => this.repositories.oci.activate(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showConfirmation('Deseja realmente ativar a OCI?', activate, null, this.handleError)
        },
        deactivate(id) {

            const deactivate = (params) => this.repositories.oci.deactivate(id, this.camelObjectKeysToSnakeRecursive(params))
                .then(() => this.$refs.DataTable.refresh())

            const openModal = async () => this.$refs.ModalDesativacao.open(deactivate)

            this.showConfirmation('Deseja realmente desativar a OCI?', openModal, null, this.handleError)
        },
    },
    mixins: [error, repository, stringCase],
}
</script>